import request, { POST } from '../../utils/request';

export default body => request('/pre-settlement-requests', { method: POST, body });
